import type { JSX } from 'react';
import { Badge, Col, FormGroup, FormParagraph, Row } from '@ksyos/design-system';
import type { IObesiQQuestionnaireResponseWithTitle } from '@common/customControls/bariatrics';
import { ObesiQState } from '@common/enums/obesiQState';

type BariPostCaroQuestionnaireResponseFormGroupProps = Readonly<{
    label: string;
    values: IObesiQQuestionnaireResponseWithTitle;
}>;

export function BariPostCaroQuestionnaireResponseFormGroup(
    props: BariPostCaroQuestionnaireResponseFormGroupProps
): JSX.Element {
    const { label, values } = props;

    return (
        <FormGroup label={label}>
            <Row>
                <Col span={1}>
                    <FormParagraph>{values.raschTransformedScore}</FormParagraph>
                </Col>
                <Col>
                    <Badge
                        color={hasAlarm(values.obesiQState) ? 'orange' : 'green'}
                        icon={hasAlarm(values.obesiQState) ? 'warning' : undefined}
                        text={hasAlarm(values.obesiQState) ? 'Ondergemiddeld' : 'Goed'}
                    ></Badge>
                </Col>
            </Row>
        </FormGroup>
    );

    function hasAlarm(obesiQState: string): boolean {
        return obesiQState === ObesiQState.notify;
    }
}
